import type { FC } from "react";
import { useSelector } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";

import { useAppDispatch } from "../../../redux/redux";
import {
  selectIsDirectSearchBadgeOpen,
  closeDirectSearchBadge,
} from "../../../redux/slices/appSlice";

import IconNew from "../../../assets/TakyonDesignSystem/components/Icon/Icon";

import imageBadgePlus from "../../../assets/img/directsearch/badge_plus.avif";

import { cn } from "../../../assets/Utils/generic";

type DirectSearchBadgeProps = {
  containerClassName?: string;
  className?: string;
  isLoading: boolean;
  openPlusModal: () => void;
};

const DirectSearchBadge: FC<DirectSearchBadgeProps> = ({
  containerClassName,
  className,
  isLoading,
  openPlusModal,
}) => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const isBadgeOpen = useSelector(selectIsDirectSearchBadgeOpen);

  return (
    <AnimatePresence>
      {isBadgeOpen && !isLoading && (
        <div
          className={containerClassName}
          onClick={() => {
            openPlusModal();
          }}
        >
          <motion.article
            className={cn(
              "flex items-center cursor-pointer relative box-border rounded-2xl bg-[#F8F8F8] ring-4 ring-inset ring-white px-3 py-4 shadow-lg gap-2.5",
              className,
            )}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
          >
            <img
              src={imageBadgePlus}
              role="presentation"
              className="size-12 shrink-0"
              alt="badge"
            />
            <div className="flex flex-col gap-0.5">
              <h3 className="text-sm mb-0">
                {t("ds.badge_title")}
              </h3>
              <p className="text-xs text-[#747474]">
                {t("ds.badge_subtitle")}
              </p>
            </div>
            <button
              type="button"
              className="absolute top-1 right-2.5 border-none bg-transparent touch-hitbox"
              onClick={(e) => {
                e.stopPropagation();
                dispatch(closeDirectSearchBadge());
              }}
            >
              <IconNew icon="close" className="size-4 fill-black/60" />
            </button>
          </motion.article>
        </div>
      )}
    </AnimatePresence>
  );
};

export default DirectSearchBadge;
